/* Template: Easy Read Slider
	 ========================================================================== */

template.component.easy_read_slider = () => {

	/* eslint-disable no-unused-vars */
	var easyReadEl = '#easy-read-slider';

	if ($(easyReadEl).length) {
		Vue.component('easy-read-nav', {
			props: ['slides', 'currentSlide'],
			template: '<div class="easy-read-slider__status">Showing slide <strong>{{ currentSlide }}</strong> of <strong>{{ slides }}</strong></div>'
		});

		new Vue({
			el: easyReadEl,
			data: {
				slides: 0,
				currentSlide: 1
			},
			computed: {
				slideIndex: function() {
					return this.currentSlide - 1;
				},
				prevSlideTitle: function() {
					return $('.easy-read-slider__slide').eq(this.slideIndex - 1).attr('data-title');
				},
				nextSlideTitle: function() {
					return $('.easy-read-slider__slide').eq(this.slideIndex + 1).attr('data-title');
				}
			},
			methods: {
				ariaState: function(n) {
					var state = (n === this.currentSlide) ? 'false' : 'true';

					return state;
				},
				changeSlide: function(next) {
					if (next) {
						this.currentSlide++;

						if (this.currentSlide > this.slides) {
							this.currentSlide = this.slides;
						}
					} else {
						this.currentSlide--;

						if (this.currentSlide < 1) {
							this.currentSlide = 1;
						}
					}
				}
			},
			created: function() {
				this.slides = $('.easy-read-slider__slide').length;
			}
		});
	}

};